import { EntityFolderEdit, EntityFolderRecord } from '@/entities/entityFolder';

export function intoEditable(data: EntityFolderRecord): EntityFolderEdit {
  return {
    ...data.data,
    entityItems: data.data.entityItems.map(entityItem => entityItem.id),
    users: data.data.users.map(user => user.id),
    parents: data.data.parents.map(parent => parent.id),
    children: data.data.children.map(child => child.id),
    labels: data.data.labels.map(label => label.label),
  };
}
